function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5EBAE7"
    },
    points: "490.452,21.547 16.92,235.764 179.068,330.053 179.068,330.053 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#36A9E1"
    },
    points: "490.452,21.547 276.235,495.079 179.068,330.053 179.068,330.053 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.137,
    y: 223.122,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 277.6362 609.0793)",
    style: {
      fill: "#FFFFFF"
    },
    width: 15.652,
    height: 47.834
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M0,234.918l174.682,102.4L277.082,512L512,0L0,234.918z M275.389,478.161L190.21,332.858 l52.099-52.099l-11.068-11.068l-52.099,52.099L33.839,236.612L459.726,41.205L293.249,207.682l11.068,11.068L470.795,52.274 L275.389,478.161z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3cc50b0b8b44d0827a94852bf3cb4128.svg";
export { ForwardRef as ReactComponent };